import { Component } from '@verndale/core';

class ImageModal extends Component {
  private loaded = false;

  constructor(el: HTMLElement) {
    super(el);

    this.loaded = (this.dom.modal as HTMLElement)?.classList.contains('image-modal--loaded');
  }

  setupDefaults() {
    this.dom = {
      triggers: document.querySelectorAll('.image-gallery__item'),
      modal: this.el,
      modalImage: document.getElementById('modal-image'),
      modalImageCaption: document.getElementById('modal-image-caption'),
      modalCloseIcon: document.getElementById('modal-close-icon'),
      modalCloseBtn: document.getElementById('modal-close-btn')
    };
  }

  addListeners() {
    (this.dom.triggers as NodeList).forEach(trigger =>
      trigger.addEventListener('click', this.handleClick.bind(this))
    );

    if (this.loaded) return;

    (this.dom.modalCloseIcon as HTMLElement).addEventListener(
      'click',
      this.handleCloseModal.bind(this)
    );
    (this.dom.modalCloseBtn as HTMLButtonElement).addEventListener(
      'click',
      this.handleCloseModal.bind(this)
    );

    window.addEventListener('click', this.handleCloseModalOutside.bind(this));

    if (!this.loaded) {
      (this.dom.modal as HTMLElement)?.classList.add('image-modal--loaded');
    }
  }

  handleClick(e: Event) {
    const trigger = e.currentTarget as HTMLElement;
    const image = trigger.querySelector('.image-gallery__image');
    const imgSrc = image?.getAttribute('src') || '';
    const imgAlt = image?.getAttribute('alt') || '';
    (this.dom.modal as HTMLElement).style.opacity = '1';
    (this.dom.modal as HTMLElement).style.pointerEvents = 'auto';
    (this.dom.modalImage as HTMLImageElement).src = imgSrc;
    (this.dom.modalImageCaption as HTMLImageElement).innerText = imgAlt;
  }

  handleCloseModal() {
    (this.dom.modal as HTMLElement).style.opacity = '0';
    (this.dom.modal as HTMLElement).style.pointerEvents = 'none';
  }

  handleCloseModalOutside(e: Event) {
    if (e.target === this.dom.modal) {
      this.handleCloseModal();
    }
  }
}

export default ImageModal;
